var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "container--large"
  }, [_c('div', {
    staticClass: "sub-top-image-wrap"
  }, [_c('div', {
    staticClass: "sub-top-image",
    style: 'background-image:url(' + _vm.src + ');'
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }